import React, { useEffect, Suspense, lazy, createElement } from 'react';
import { OpeningLead } from './components/OpeningLead';
import { LiveActivityPopup } from './components/LiveActivityPopup';
import { LuxuryStickyBar } from './components/LuxuryStickyBar';
import { TopFlashBar } from './components/TopFlashBar';
// Lazy load below-the-fold components
const EmpathySection = lazy(() => import('./components/EmpathySection').then(m => ({
  default: m.EmpathySection
})));
const FailedSolutions = lazy(() => import('./components/FailedSolutions').then(m => ({
  default: m.FailedSolutions
})));
const ProductContents = lazy(() => import('./components/ProductContents').then(m => ({
  default: m.ProductContents
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const CTASection = lazy(() => import('./components/CTASection').then(m => ({
  default: m.CTASection
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
function SectionLoader() {
  return <div className="w-full h-32 animate-pulse bg-[var(--bg-elevated)]/50" data-id="element-0" />;
}
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    const w = window as any;
    if (w.fbq) return;
    const fbq: any = function (...args: any[]) {
      fbq.callMethod ? fbq.callMethod.apply(fbq, args) : fbq.queue.push(args);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [] as any[];
    w.fbq = fbq;
    w._fbq = fbq;
    fbq('init', '2190085458428751');
    fbq('track', 'PageView');
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
  }, []);
  return <main className="celestial-bg w-full min-h-screen bg-[var(--bg-deep)] text-[var(--text-primary)] overflow-x-hidden selection:bg-[var(--accent)] selection:text-[var(--bg-deep)]" data-id="element-1">
      <TopFlashBar data-id="element-2" />
      <LuxuryStickyBar data-id="element-3" />
      <LiveActivityPopup data-id="element-4" />

      {/* BLOCK 1: HERO */}
      <OpeningLead data-id="element-5" />

      <div className="gold-divider" data-id="element-6" />

      <Suspense fallback={<SectionLoader data-id="element-8" />} data-id="element-7">
        {/* BLOCK 2: EL ESPEJO */}
        <EmpathySection data-id="element-9" />

        {/* BLOCK 3: LA SOLUCIÓN */}
        <FailedSolutions data-id="element-10" />

        <div className="gold-divider" data-id="element-11" />

        {/* BLOCK 4: LA PROPUESTA DE VALOR */}
        <ProductContents data-id="element-12" />

        {/* BLOCK 5: PRUEBA SOCIAL */}
        <TestimonialsSection data-id="element-13" />

        <div className="gold-divider" data-id="element-14" />

        {/* BLOCK 6: GARANTÍA DE HIERRO */}
        <CTASection data-id="element-15" />

        <Footer data-id="element-16" />
      </Suspense>
    </main>;
}